import React from "react";

import useTheme from "../../hooks/useTheme";
import { PlatformType } from "../../types/types";
import useStyles from "../../hooks/useStyles";

export default function AppStore(props: {
  minVersion?: string | number;
  store?: boolean;
  style?: React.CSSProperties;
}) {
  const theme = useTheme();

  return (
    <div
      style={{
        ...props.style,
      }}
    >
      <img
        src={theme.images.appStore}
        style={useStyles.iconStore}
        alt={PlatformType.iOS}
      />
      <h3>{props?.minVersion}</h3>
    </div>
  );
}
